<template>
  <v-container fluid fill-height>
    <v-app-bar app clipped-left>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title></v-toolbar-title>

      <v-spacer></v-spacer>
      <v-toolbar-title>{{ info.username }}</v-toolbar-title>
      <v-btn icon>
        <v-icon @click="logout">mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app clipped>
      <v-list>
        <v-list-group
          v-for="menu in menuList"
          v-if="checkMenu(jwt.role_id, menu)==true"
          :prepend-icon="menu.icon"
          no-action
        ><!-- v-if="menu.enableRoleIds.indexOf(jwt.role_id) !== -1" -->
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{ menu.text }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-for="sub in menu.subList" @click>
            <v-list-item-content>
              <v-list-item-title :data-link="sub.link" @click="link">{{ sub.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-layout>
      <hgroup
        v-if="$router.history.current.path === '/'"
        class="d-flex flex-column justify-center align-center mx-auto"
      >
        <h2>歡迎</h2>
        <h1>後台管理系統</h1>
      </hgroup>

      <router-view></router-view>
    </v-layout>

    <v-footer app>
      <span>&copy; 2019</span>
    </v-footer>
  </v-container>
</template>



<script>
import { mapState, mapActions } from "vuex";

import adminApi from "@/api/admin";

export default {
  components: {},

  mixins: [],

  props: [],
  data() {
    return {
      drawer: null,

      menuList: [
        {
          enableRoleIds: [100, 200, 300, 400],
          icon: "mdi-chart-bar",
          text: "Dashboard",
          subList: [
            {
              text: "總覽",
              link: "/dashboard/overview"
            },
            {
              text: "銷售紀錄",
              link: "/dashboard/report"
            }
          ]
        },
        {
          enableRoleIds: [100, 200, 300, 400],
          icon: "mdi-kickstarter",
          text: "機器管理",
          subList: [
            {
              text: "所有機器列表",
              link: "/machine/list"
            }
          ]
        },
        {
          enableRoleIds: [100, 200, 400],
          icon: "mdi-wallet",
          text: "結帳管理",
          subList: [
            {
              text: "卡機結帳",
              link: "/settlements"
            }
          ]
        },
        {
          enableRoleIds: [100, 200],
          icon: "mdi-account-edit",
          text: "使用者管理",
          subList: [
            {
              text: "使用者列表",
              link: "/user/list"
            }
          ]
        },
        {
          enableRoleIds: [100, 200],
          icon: "mdi-sale",
          text: "優惠方案管理",
          subList: [
            {
              text: "優惠方案列表",
              link: "/deal/list"
            },
            {
              text: "優惠時段設定",
              link: "/weekday/list"
            }
          ]
        },
        {
          enableRoleIds: [200],
          icon: "mdi-numeric",
          text: "活動序號管理",
          subList: [
            {
              text: "活動列表",
              link: "/active/list"
            }
          ]
        }
      ]
    };
  },

  computed: {
    ...mapState("admin", ["jwt"]),
    ...mapState("admin", ["info"])
  },
  watch: {},
  methods: {
    ...mapActions("admin", ["set_info"]),

    logout() {
      adminApi
        .logout()
        .then(res => {
          this.$router.push("/login");
        })
        .catch(err => {});
    },

    link(evt) {
      const target = evt.currentTarget;
      const link = $(target).attr("data-link");
      this.$router.push(link);
    },
    checkMenu(role_id, menu) {

        role_id = parseInt(role_id);

        if(menu.enableRoleIds.indexOf(role_id) !== -1){
            return true
        }

        return false;
    }
  },

  mounted() {
    adminApi
      .self()
      .then(res => {
        const { username, email } = res;

        this.set_info({ username, email });
      })
      .catch(err => {});
  }
};
</script>

<style lang="scss" scoped>
</style>
